import MojitoCore from 'mojito/core';
import MojitoServices from 'mojito/services';
import SportCouponView from './view/index.js';
import { connect } from 'react-redux';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { selectors: menusSelectors, descriptor: MenusDescriptor } =
    MojitoServices.SportsContent.Menus;
const { selectMenuContentInfo } = menusSelectors;
const { selectTimeZoneGmt } = MojitoServices.UserSettings.selectors;

class SportCoupon extends UIViewImplementation {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.requestData(this.props.timeZoneGmt);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.timeZoneGmt !== this.props.timeZoneGmt) {
            this.requestData(this.props.timeZoneGmt);
        }
    }

    requestData(timeZone) {
        this.controllerHelper().requestData(MenusDescriptor.create(timeZone));
    }

    render() {
        const { sportId, couponId, contentInfo } = this.props;
        return (
            <SportCouponView
                sportId={sportId}
                couponId={couponId}
                todayEventGroupId={contentInfo.today}
                tomorrowEventGroupId={contentInfo.tomorrow}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    contentInfo: selectMenuContentInfo(ownProps.sportId, selectTimeZoneGmt(state), state),
    timeZoneGmt: selectTimeZoneGmt(state),
});

export default connect(mapStateToProps)(SportCoupon);
